module.exports = __webpack_public_path__ + "img/img26.5f573514.jpg";